// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import receptionEntity from './entities/reception.json';
import receptionMenu from '../pages/reception/menu.json';
import receptionFullForm from '../pages/reception/forms/full.json';
import receptionContextForm from '../pages/reception/forms/context.json';
import receptionMiniForm from '../pages/reception/forms/mini.json';
import receptionLookupForm from '../pages/reception/forms/lookup.json';
import receptionTableView from '../pages/reception/views/table.json';
import receptionStagesView from '../pages/reception/views/stages.json';
import receptionCardsView from '../pages/reception/views/cards.json';
import receptionSplitView from '../pages/reception/views/split.json';
import receptionCalendarView from '../pages/reception/views/calendar.json';
import receptionDashboardView from '../pages/reception/views/dashboard.json';

/** Тип запису «Прийом» зі сторінками пакета: меню, форми та подання з pages/reception/. */
export const receptionDefinition: IRecordTypeDefinition = {
  ...receptionEntity,
  views: assembleViewSet({
      table: receptionTableView,
      stages: receptionStagesView,
      cards: receptionCardsView,
      split: receptionSplitView,
      calendar: receptionCalendarView,
      dashboard: receptionDashboardView,
  }),
  form: receptionFullForm,
  forms: { full: receptionFullForm, context: receptionContextForm, mini: receptionMiniForm, lookup: receptionLookupForm },
  menu: receptionMenu,
} as IRecordTypeDefinition;
